import { browserHistory } from 'react-router';
import { delay, call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import * as apiCustomTab from '../../services/custom_tab/api_custom_tab';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import {
  CUSTOM_FIELD,
  CUSTOM_FORM,
  CUSTOM_TAB,
} from '../../constants/constant_doc_types';
import * as sectionTableActions from '../../components/common/form/SectionTable/actions';
import { getErrorMessage } from '../../utils';

export function* fetchListCustomTabSaga(app) {
  yield takeLatest('FETCH_LIST_CUSTOM_TAB', callFetchListCustomTab, app);
}

function* callFetchListCustomTab(app, action) {
  const { filters, silent } = action;

  try {
    yield common.showProgressListTable(silent);

    const dataParams = {
      filters,
      list_type: CUSTOM_TAB,
    };
    const tableData = yield call(apiCommon.getDocs, app, dataParams);

    yield call(common.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

export function* fetchCustomTabForEditSaga(app) {
  yield takeEvery('FETCH_CUSTOM_TAB_FOR_EDIT', callFetchCustomTabForEdit, app);
}

function* callFetchCustomTabForEdit(app, action) {
  const { id, silent } = action;

  try {
    if (id) {
      yield common.showProgressDataById(silent);

      const params = { id };
      const doc = yield call(apiCustomTab.fetchCustomTabById, app, params);
      
      yield common.doneDataById(doc);
    }
  } catch (error) {
    yield put({ type: 'FETCH_DATA_BY_ID_ERROR', error: error });
  }
}

export function* saveCustomTabSaga(app) {
  yield takeLatest('SAVE_CUSTOM_TAB', callSaveCustomTab, app);
}

function* callSaveCustomTab(app, action) {
  const { tenant, user } = yield select();
  const { data } = action;

  try {
    yield put({ type: 'SAVE_RECORD_INPROGRESS' });

    const params = { data, tenant, user };
    const result = yield call(apiCustomTab.saveCustomTab, app, params);

    yield call(callFetchCustomTabForEdit, app, {
      id: result.id,
      silent: true,
    });

    browserHistory.push(`/admin/custom/tab/edit/${result.id}`);

    yield common.doneSaveRecord(result, 'Custom Tab was saved');
  } catch (e) {
    yield common.showErrorSaveRecord(e);
  }
}

export function* deleteCustomTabSaga(app) {
  yield takeEvery('DELETE_CUSTOM_TAB', callDeleteCustomTab, app);
}

function* callDeleteCustomTab(app, action) {
  const { tenant, user } = yield select();
  const { id } = action;

  try {
    yield put({ type: 'DELETE_RECORD_INPROGRESS' });

    const params = { tenant, user, id };

    yield call(apiCustomTab.deleteCustomTab, app, params);
    yield put({
      type: 'DELETE_RECORD_DONE',
      payload: { id, docType: CUSTOM_TAB },
    });
    yield delay(2000);

    browserHistory.push('/admin/custom/tab');
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error });
  }
}

export function* getCustomTabCustomFieldsSaga(app) {
  yield takeEvery('GET_CUSTOM_TAB_CUSTOM_FIELDS', callGetCustomTabCustomFields, app);
}

function* callGetCustomTabCustomFields(app, action) {
  const { key, payload } = action;
  yield put(sectionTableActions.setSectionTableLoader(key, true));

  try {
    const { data, total, limit, skip } = yield call(apiCommon.getDocs, app, {
      ...payload,
      filters: {
        ...payload.filters,
      },
      list_type: CUSTOM_FIELD,
    });

    const meta = {
      total,
      limit,
      skip,
    };

    yield put(sectionTableActions.setSectionTableData(key, { data, meta }));
  } catch (err) {
    yield put(sectionTableActions.setSectionTableError(key, true, getErrorMessage(err)));
  }
}

export function* getCustomTabCustomFormsSaga(app) {
  yield takeEvery('GET_CUSTOM_TAB_CUSTOM_FORMS', callGetCustomTabCustomForms, app);
}

function* callGetCustomTabCustomForms(app, action) {
  const { key, payload } = action;
  yield put(sectionTableActions.setSectionTableLoader(key, true));

  try {
    const { data, total, limit, skip } = yield call(apiCommon.getDocs, app, {
      ...payload,
      filters: {
        ...payload.filters,
      },
      list_type: CUSTOM_FORM,
    });

    const meta = {
      total,
      limit,
      skip,
    };

    yield put(sectionTableActions.setSectionTableData(key, { data, meta }));
  } catch (err) {
    yield put(sectionTableActions.setSectionTableError(key, true, getErrorMessage(err)));
  }
}
